module.exports = {
    'grossSalary':
        'B.1 (a) - Gross salary, wages or leave pay (incl. overtime)',
    'feesCommissionsBonuses':
        'B.1 (b) - Fees (incl. director fees), commissions or bonuses',
    'allowances':
        'B.1 (c) - Gross tips, perquisites, awards/rewards or other allowances',
    'employerMtd':
        'B.1 (d) - Income tax borne by employer in respect of his employee',
    'shareOption':
        'B.1 (e) - Employee Share Option Scheme (ESOS) benefit',
    'gratuity':
        'B.1 (f) - Gratuity',
    'benefits':
        'B.3 - Benefits in kind',
    'livingAccommodation':
        'B.4 - Value of living accomodations',
    'unapprovedPension':
        'B.5 - Refund from unapproved pension',
    'compensation':
        'B.6 - Compensation for loss of employment',
    'pensions':
        'C.1 - Pension',
    'annuities':
        'C.2 - Annuities or other periodical payments',
    'relief':
        'D.5 (a) - Relief claim by employee via Form TP1',
    'zakatRelief':
        'D.5 (b) - Zakat relief claim by employee via Form TP1',
    'taxExemptAmount':
        'F - Tax Exempt Allowances / Perquisites / Gifts / Benefits'
};



// WEBPACK FOOTER //
// ./app/employer/views/settings/eaFields.js